import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostConfirmRegistrationData,
	PostConfirmRegistrationDataModel,
	PostConfirmRegistrationDataParams,
} from 'domain/usecases/private/home/post-confirm-registration-data';

export class RemotePostConfirmRegistrationData implements PostConfirmRegistrationData {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostConfirmRegistrationDataModel>,
	) {}

	async post(params: PostConfirmRegistrationDataParams): Promise<PostConfirmRegistrationDataModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
